import type { ValueOf } from '@shared/lib'
import { BadgeVariant } from '@shared/ui/Badge/types'

export const PaymentStatus = {
  paid: 'paid',
  unpaid: 'unpaid',
  error: 'error',
  pending: 'pending',
} as const
export type PaymentStatus = ValueOf<typeof PaymentStatus>

export const PaymentStatusBadgeMap: Record<PaymentStatus, BadgeVariant> = {
  [PaymentStatus.paid]: BadgeVariant.green,
  [PaymentStatus.unpaid]: BadgeVariant.red,
  [PaymentStatus.error]: BadgeVariant.red,
  [PaymentStatus.pending]: BadgeVariant.violet,
}

export interface PaymentParticipant {
  id: number
  email: string
  full_name_ru: string
  full_name_en: string
}

export interface Payment {
  id: number
  participant: PaymentParticipant | null
  description: string | null
  amount: string
  status: PaymentStatus
  created_at: string
  gateway_id: string | null
  download_url: string
  /** Человекочитаемый номер платежа: «FEMO-PAY-ID-7146» */
  transaction_id?: string | null
  /** Название олимпиады строкой — не объект (проверено на staging 2026-08-04) */
  olympiad?: string | null
  promocode?: string | null
}

export interface PaymentSummary {
  total_amount: number
  successful_payments: number
  pending_confirmations: number
  payments_with_errors: number
}

export interface PaymentsPage {
  count: number
  next: string | null
  previous: string | null
  results: Payment[]
  summary: PaymentSummary
}

export interface Balance {
  balance: number
  currency: string
}

export interface TopUpRequest {
  amount: number
  promocode?: string
}

export interface TopUpResponse {
  pg_redirect_url?: string
  pg_status?: string
  detail?: string
}

export const CURRENCEIS: Record<string, string> = {
  KZT: '₸',
  USD: '$',
  RUB: '₽',
  EUR: '€',
}

export type CURRENCEIS = ValueOf<typeof CURRENCEIS>
